import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  deleteEmail,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";

export class DeleteEmailModal extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, email } = this.props;

    this.props.deleteEmail(accountId, email.id).then(this.props.closeModal);
  }

  render() {
    const { email } = this.props;
    const content = email?.name ? `Remove ${email.name}` : "Removing";

    return (
      <Modal>
        <ModalHeader>Delete Email?</ModalHeader>
        <ModalContent>{content}</ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.delete}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

DeleteEmailModal.propTypes = {
  deleteEmail: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const email = state.entities.email[id];

  return {
    accountId,
    id,
    email,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  deleteEmail,
  emailTemplatesList,
  gotoUrl,
})(DeleteEmailModal);
